var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppSheetProjectElement',{attrs:{"title":_vm.tower.name,"enter-to":_vm.towerRouteObject,"exterior-tour360-to":_vm.exteriorTour360RouteObject}})
}
var staticRenderFns = []

export { render, staticRenderFns }